import type { PdfFontKey } from "@/src/lib/pdf/fonts";
import { buildFontsCssHref } from "@/src/lib/pdf/fonts";
import type { ScriptFallbackKey } from "@/src/lib/pdf/script-fallbacks";

export function EditorFontStyles({
  fontFamily,
  scriptFallbacks = [],
}: Readonly<{
  fontFamily: PdfFontKey;
  scriptFallbacks?: readonly ScriptFallbackKey[];
}>) {
  const href = buildFontsCssHref(fontFamily, { scripts: scriptFallbacks });

  return (
    <link
      key={`editor-font-${fontFamily}-${scriptFallbacks.join(",")}`}
      rel="stylesheet"
      href={href}
    />
  );
}
